import colors from 'styles/theme/colors';

export default function CoordinatePatientsIcon({ width = 24, height = 24, color = colors.blue100 }) {
  return (
    <svg width={width} height={height} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.375 21C11.375 22.2348 11.6075 23.4152 12.0311 24.5H0C0 19.0718 3.53047 14.4684 8.42042 12.8605C6.51121 11.6104 5.25 9.45247 5.25 7C5.25 3.134 8.384 0 12.25 0C16.116 0 19.25 3.134 19.25 7C19.25 8.54241 18.7511 9.96832 17.906 11.1252C17.4109 11.8027 16.7128 12.2746 16.0138 12.7471C15.7745 12.9088 15.5352 13.0706 15.3038 13.2407C12.9212 14.9928 11.375 17.8159 11.375 21Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28 21C28 24.8659 24.8659 28 21 28C17.134 28 14 24.8659 14 21C14 17.134 17.134 14 21 14C24.8659 14 28 17.134 28 21ZM19.6875 17.5V19.6875H17.5V22.3125H19.6875V24.5H22.3125V22.3125H24.5V19.6875H22.3125V17.5H19.6875Z'
        fill={color}
      />
    </svg>
  );
}
